/** Engine + player constants shared by client and server. Units: metres, seconds, radians. */
/** Player controller speeds (P0-T09). */
export const WALK_SPEED = 2.1;
export const RUN_SPEED = 5.6;
/** Server speed cap on foot (SPEC-08 §3). Moves faster than this are rejected. */
export const MAX_FOOT_SPEED = 7;
/** Teleport threshold: a jump > 2 m between ticks without a sanctioned teleport is rejected. */
export const TELEPORT_MAX_STEP = 2;
/** Player capsule (P0-T08): radius 0.34 m, total height 1.75 m. */
export const CAPSULE_RADIUS = 0.34;
export const CAPSULE_HEIGHT = 1.75;
/** Max slope the capsule can walk up (degrees). */
export const MAX_SLOPE_DEG = 40;
/** Max step the capsule can climb (m). */
export const MAX_STEP_HEIGHT = 0.35;
/** Movement update rate client -> server (SPEC-08 §3). */
export const MOVE_RATE_HZ = 20;
/** Remote avatar interpolation delay (SPEC-08 §4). */
export const INTERPOLATION_DELAY_MS = 100;
/** World clock default (Q-11 default): 48 real minutes per game day => timeScale 30. */
export const DEFAULT_TIME_SCALE = 30;
/** Colyseus room names. */
export const ROOM_ZONE = 'zone';
